<!-- HEADER -->
<div class="modal-header edit-modal-header text-white px-3 px-md-4 py-3">
  <div class="edit-modal-title-wrap">
    <div class="edit-modal-icon">
      <i class="bi bi-building"></i>
    </div>
    <div>
      <h5 class="modal-title mb-1 fw-semibold">Editar Fuente</h5>
      <small class="edit-modal-subtitle">
        {{ fountain?.codigoINE || 'Sin código' }} · {{ fountain?.nombre || fountain?.razonSocial || 'Fuente seleccionada' }}
      </small>
    </div>
  </div>

  <button type="button" class="btn-close btn-close-white edit-modal-close" data-bs-dismiss="modal" aria-label="Cerrar"></button>
</div>

<form [formGroup]="editForm" (ngSubmit)="saveChanges()" class="edit-fountain-form">

  <!-- BODY -->
  <div class="modal-body edit-modal-body px-3 px-md-4 py-3 py-md-4">

    <!-- ALERTAS -->
    @if (success()) {
    <div class="alert alert-success border-0 shadow-sm rounded-3 py-2 mb-3">
      <i class="bi bi-check-circle me-1"></i>
      Guardado con éxito.
    </div>
    }

    @if (error()) {
    <div class="alert alert-danger border-0 shadow-sm rounded-3 py-2 mb-3">
      <i class="bi bi-exclamation-triangle me-1"></i>
      {{ error() }}
    </div>
    }

    @if (boletaMessage()) {
    <div class="alert border-0 shadow-sm rounded-3 py-2 mb-3" [class.alert-success]="boletaMessageType() === 'success'"
      [class.alert-danger]="boletaMessageType() === 'danger'" style="white-space: pre-line;">
      <i class="bi me-1" [class.bi-check-circle]="boletaMessageType() === 'success'"
        [class.bi-exclamation-triangle]="boletaMessageType() === 'danger'"></i>
      {{ boletaMessage() }}
    </div>
    }

    <div class="edit-modal-summary">
      <div class="edit-modal-summary-item">
        <span class="edit-modal-summary-label">Código</span>
        <strong>{{ fountain?.codigoINE || 'Sin código' }}</strong>
      </div>
      <div class="edit-modal-summary-item">
        <span class="edit-modal-summary-label">Estado</span>
        <strong>{{ fountain?.estado || 'Sin estado' }}</strong>
      </div>
      <div class="edit-modal-summary-item edit-modal-summary-item-wide">
        <span class="edit-modal-summary-label">Nombre visible</span>
        <strong>{{ fountain?.nombre || fountain?.razonSocial || 'Fuente seleccionada' }}</strong>
      </div>
    </div>

    <section class="edit-form-section">
      <h6 class="edit-section-title">Identificación</h6>

      <div class="row g-3">
        <div class="col-12">
          <label class="form-label fw-semibold">Código INE</label>
          <input class="form-control form-control-lg" placeholder="Ej: F12345" formControlName="codigoINE" />
        </div>

        <div class="col-12">
          <label class="form-label fw-semibold">Razón Social</label>
          <input class="form-control form-control-lg" formControlName="razonSocial" />
        </div>

        <div class="col-12">
          <div class="d-flex flex-column flex-lg-row align-items-lg-end gap-2">
            <div class="flex-grow-1">
              <label class="form-label fw-semibold">Nombre</label>
              <input class="form-control form-control-lg" formControlName="nombre" />
            </div>

            <button
              type="button"
              class="btn btn-outline-info edit-inline-action flex-shrink-0"
              (click)="openGoogleMaps()"
              [disabled]="!canOpenGoogleMaps()">
              <i class="bi bi-geo-alt me-1"></i>
              Ver en Google Maps
            </button>
          </div>
        </div>

        <div class="col-12">
          <label class="form-label fw-semibold">Estado</label>
          <select class="form-select form-select-lg edit-desktop-select" formControlName="estado">
            <option value="A">Activo</option>
            <option value="P">Pendiente</option>
            <option value="I">Inactivo</option>
          </select>
          <div class="edit-mobile-picker">
            <button
              type="button"
              class="btn btn-outline-info edit-mobile-picker__button"
              (click)="openMobileSelect('estado', 'Estado', statusOptions)">
              <span class="edit-mobile-picker__value">{{ getMobileSelectionLabel('estado', 'Seleccione estado') }}</span>
              <span class="edit-mobile-picker__action">
                <i class="bi bi-search"></i>
                Buscar
              </span>
            </button>
          </div>
        </div>
      </div>
    </section>

    <section class="edit-form-section">
      <h6 class="edit-section-title">Dirección y Ubicación</h6>

      <div class="row g-3">
        <div class="col-12">
          <label class="form-label fw-semibold">Dirección</label>
          <input class="form-control form-control-lg" formControlName="direccion" />
        </div>

        <div class="col-12 col-lg-6">
          <label class="form-label fw-semibold">Departamento</label>
          <select formControlName="fkDepartamento" class="form-control form-control-lg edit-desktop-select" (change)="onDepartamentoChange()">
            <option [ngValue]="0">Seleccione...</option>
            @for (d of departaments; track d.id) {
            <option [ngValue]="d.id">{{ d.nombre }}</option>
            }
          </select>
          <div class="edit-mobile-picker">
            <button
              type="button"
              class="btn btn-outline-info edit-mobile-picker__button"
              (click)="openMobileSelect('fkDepartamento', 'Departamento', getDepartamentoMobileOptions())">
              <span class="edit-mobile-picker__value">{{ getMobileSelectionLabel('fkDepartamento', 'Seleccione departamento') }}</span>
              <span class="edit-mobile-picker__action">
                <i class="bi bi-search"></i>
                Buscar
              </span>
            </button>
          </div>
        </div>

        <div class="col-12 col-lg-6">
          <label class="form-label fw-semibold">Municipio</label>
          <select formControlName="fkMunicipio" class="form-control form-control-lg edit-desktop-select" (change)="onMunicipioChange()">
            <option [ngValue]="0">Seleccione...</option>
            @for (m of municipalities(); track m.id) {
            <option [ngValue]="m.id">{{ m.nombre }}</option>
            }
          </select>
          <div class="edit-mobile-picker">
            <button
              type="button"
              class="btn btn-outline-info edit-mobile-picker__button"
              (click)="openMobileSelect('fkMunicipio', 'Municipio', getMunicipioMobileOptions())">
              <span class="edit-mobile-picker__value">{{ getMobileSelectionLabel('fkMunicipio', 'Seleccione municipio') }}</span>
              <span class="edit-mobile-picker__action">
                <i class="bi bi-search"></i>
                Buscar
              </span>
            </button>
          </div>
        </div>

        <div class="col-12 col-lg-6">
          <label class="form-label fw-semibold">Zona</label>
          <input type="number" formControlName="zona" class="form-control form-control-lg" min="0" step="1"
            (input)="onZonaChange()" />
        </div>

        <div class="col-12 col-lg-6">
          <label class="form-label fw-semibold">Código Postal</label>
          <input type="text" class="form-control form-control-lg" [value]="codigoPostalDescripcion" readonly />
          <input type="hidden" formControlName="fkCodigoPostal" />
        </div>
      </div>
    </section>

    <section class="edit-form-section">
      <h6 class="edit-section-title">Geolocalización</h6>

      <div class="row g-3 mb-3">
        <div class="col-12 col-lg-4">
          <label class="form-label fw-semibold">Latitud</label>
          <input type="number" step="0.0000000001" class="form-control form-control-lg" formControlName="gpsLatitud" />
        </div>

        <div class="col-12 col-lg-4">
          <label class="form-label fw-semibold">Longitud</label>
          <input type="number" step="0.0000000001" class="form-control form-control-lg" formControlName="gpsLongitud" />
        </div>

        <div class="col-12 col-lg-4">
          <label class="form-label fw-semibold">Altitud</label>
          <input type="number" class="form-control form-control-lg" formControlName="gpsAltitud" />
        </div>
      </div>

      <div class="row g-3 align-items-end">
        <div class="col-12 col-lg-5">
          <label class="form-label fw-semibold">Fecha GPS</label>
          <input type="datetime-local" class="form-control form-control-lg" formControlName="gpsFecha" />
        </div>

        <div class="col-12 col-lg-7">
          <button type="button"
            class="btn btn-info text-white edit-inline-action w-100 d-flex align-items-center justify-content-center gap-2"
            [disabled]="geoLoading()" (click)="useCurrentLocation()">
            @if (geoLoading()) {
            <span class="spinner-border spinner-border-sm"></span>
            Obteniendo ubicación...
            } @else {
            <i class="bi bi-geo-alt-fill"></i>
            Usar ubicación actual
            }
          </button>
        </div>
      </div>
    </section>

    <section class="edit-form-section">
      <h6 class="edit-section-title">Contacto</h6>

      <div class="row g-3">
        <div class="col-12 col-lg-6">
          <label class="form-label fw-semibold">Teléfonos</label>
          <input type="text" class="form-control form-control-lg" placeholder="Ej: 3245-1540 Ext 357"
            formControlName="telefonos" />
        </div>

        <div class="col-12 col-lg-6">
          <label class="form-label fw-semibold">Email</label>
          <input type="email" class="form-control form-control-lg" formControlName="email" (blur)="applyDefaultEmail()" />
        </div>
      </div>
    </section>

    <section class="edit-form-section">
      <h6 class="edit-section-title">Programación de Visitas</h6>

      <div class="row g-3 mb-3">
        <div class="col-12 col-lg-6">
          <label class="form-label fw-semibold">Usuario Responsable</label>
          <select class="form-select form-select-lg edit-desktop-select" formControlName="fkUsuario">
            <option [ngValue]="0">Seleccione...</option>
            @for (u of usuarios(); track u.pk) {
            <option [ngValue]="u.pk">{{ u.descripcion }}</option>
            }
          </select>
          <div class="edit-mobile-picker">
            <button
              type="button"
              class="btn btn-outline-info edit-mobile-picker__button"
              (click)="openMobileSelect('fkUsuario', 'Usuario Responsable', getUsuarioMobileOptions())">
              <span class="edit-mobile-picker__value">{{ getMobileSelectionLabel('fkUsuario', 'Seleccione usuario responsable') }}</span>
              <span class="edit-mobile-picker__action">
                <i class="bi bi-search"></i>
                Buscar
              </span>
            </button>
          </div>
        </div>

        <div class="col-12 col-lg-6">
          <label class="form-label fw-semibold">
            Periodo
            @if (periodoTitulo() && periodoTitulo().toLowerCase() !== 'periodo') {
            <span class="text-muted">({{ periodoTitulo() }})</span>
            }
          </label>
          <select class="form-select form-select-lg edit-desktop-select" formControlName="periodo">
            <option [ngValue]="0">Seleccione...</option>
            @for (i of periodos(); track i) {
            <option [value]="i">{{ periodoTitulo() }} {{ i }}</option>
            }
          </select>
          <div class="edit-mobile-picker">
            <button
              type="button"
              class="btn btn-outline-info edit-mobile-picker__button"
              (click)="openMobileSelect('periodo', periodoTitulo(), getPeriodoMobileOptions())">
              <span class="edit-mobile-picker__value">{{ getMobileSelectionLabel('periodo', 'Seleccione período') }}</span>
              <span class="edit-mobile-picker__action">
                <i class="bi bi-search"></i>
                Buscar
              </span>
            </button>
          </div>
        </div>
      </div>

      <div class="row g-3 mb-3">
        <div class="col-12 col-lg-6">
          <label class="form-label fw-semibold">Orden de Ruta</label>
          <input
            type="number"
            class="form-control form-control-lg"
            formControlName="ordenRuta"
            min="0"
            step="1"
            inputmode="numeric"
            placeholder="0"
            (keydown)="preventInvalidIntegerInput($event)"
            (input)="normalizeNonNegativeInteger('ordenRuta')" />
        </div>

        <div class="col-12 col-lg-6">
          <label class="form-label fw-semibold">Periodicidad</label>
          <select class="form-select form-select-lg edit-desktop-select" formControlName="fkPeriodicidadVisita">
            <option [ngValue]="0">Seleccione...</option>
            @for (p of periodicidades(); track p.pk) {
            <option [ngValue]="p.pk">{{ p.descripcion }}</option>
            }
          </select>
          <div class="edit-mobile-picker">
            <button
              type="button"
              class="btn btn-outline-info edit-mobile-picker__button"
              (click)="openMobileSelect('fkPeriodicidadVisita', 'Periodicidad', getPeriodicidadMobileOptions())">
              <span class="edit-mobile-picker__value">{{ getMobileSelectionLabel('fkPeriodicidadVisita', 'Seleccione periodicidad') }}</span>
              <span class="edit-mobile-picker__action">
                <i class="bi bi-search"></i>
                Buscar
              </span>
            </button>
          </div>
        </div>
      </div>

      <div class="row g-3">
        <div class="col-12 col-lg-6">
          <label class="form-label fw-semibold">Día de Visita</label>
          <select class="form-select form-select-lg edit-desktop-select" formControlName="fkDiaVisita">
            <option [ngValue]="0">Seleccione...</option>
            @for (d of diasVisita(); track d.pk) {
            <option [ngValue]="d.pk">{{ d.descripcion }}</option>
            }
          </select>
          <div class="edit-mobile-picker">
            <button
              type="button"
              class="btn btn-outline-info edit-mobile-picker__button"
              (click)="openMobileSelect('fkDiaVisita', 'Día de Visita', getDiaVisitaMobileOptions())">
              <span class="edit-mobile-picker__value">{{ getMobileSelectionLabel('fkDiaVisita', 'Seleccione día de visita') }}</span>
              <span class="edit-mobile-picker__action">
                <i class="bi bi-search"></i>
                Buscar
              </span>
            </button>
          </div>
        </div>
      </div>
    </section>

    <section class="edit-form-section">
      <h6 class="edit-section-title">Jornadas</h6>

      <div class="row g-3">
        <div class="col-12 col-md-6 col-xl-3">
          <label class="form-label fw-semibold">Inicio 1ra Jornada</label>
          <input type="time" class="form-control form-control-lg" formControlName="horaInicioPrimeraJornada" />
        </div>

        <div class="col-12 col-md-6 col-xl-3">
          <label class="form-label fw-semibold">Fin 1ra Jornada</label>
          <input type="time" class="form-control form-control-lg" formControlName="horaFinalPrimeraJornada" />
        </div>

        <div class="col-12 col-md-6 col-xl-3">
          <label class="form-label fw-semibold">Inicio 2da Jornada</label>
          <input type="time" class="form-control form-control-lg" formControlName="horaInicioSegundaJornada" />
        </div>

        <div class="col-12 col-md-6 col-xl-3">
          <label class="form-label fw-semibold">Fin 2da Jornada</label>
          <input type="time" class="form-control form-control-lg" formControlName="horaFinalSegundaJornada" />
        </div>

        @if (editForm.errors?.['traslapeJornadas']) {
        <div class="col-12">
          <div class="invalid-feedback d-block mb-0">
            La segunda jornada se traslapa con la primera.
          </div>
        </div>
        }

        @if (editForm.errors?.['segundaJornadaInvalida']) {
        <div class="col-12">
          <div class="invalid-feedback d-block mb-0">
            La hora final debe ser mayor a la inicial.
          </div>
        </div>
        }
      </div>
    </section>

    <section class="edit-form-section">
      <h6 class="edit-section-title">Clasificación y Requisitos</h6>

      <div class="row g-3">
        <div class="col-12 col-lg-4">
          <label class="form-label fw-semibold">Requiere Audio</label>
          <select class="form-select form-select-lg edit-desktop-select" formControlName="requiereAudio">
            <option value="S">Sí</option>
            <option value="N">No</option>
          </select>
          <div class="edit-mobile-picker">
            <button
              type="button"
              class="btn btn-outline-info edit-mobile-picker__button"
              (click)="openMobileSelect('requiereAudio', 'Requiere Audio', yesNoOptions)">
              <span class="edit-mobile-picker__value">{{ getMobileSelectionLabel('requiereAudio', 'Seleccione una opción') }}</span>
              <span class="edit-mobile-picker__action">
                <i class="bi bi-search"></i>
                Buscar
              </span>
            </button>
          </div>
        </div>

        <div class="col-12 col-lg-4">
          <label class="form-label fw-semibold">Requiere Imagen</label>
          <select class="form-select form-select-lg edit-desktop-select" formControlName="requiereImagen">
            <option value="S">Sí</option>
            <option value="N">No</option>
          </select>
          <div class="edit-mobile-picker">
            <button
              type="button"
              class="btn btn-outline-info edit-mobile-picker__button"
              (click)="openMobileSelect('requiereImagen', 'Requiere Imagen', yesNoOptions)">
              <span class="edit-mobile-picker__value">{{ getMobileSelectionLabel('requiereImagen', 'Seleccione una opción') }}</span>
              <span class="edit-mobile-picker__action">
                <i class="bi bi-search"></i>
                Buscar
              </span>
            </button>
          </div>
        </div>
      </div>
    </section>

    <section class="edit-form-section">
      <h6 class="edit-section-title">Datos Empresariales</h6>

      <div class="row g-3">
        <div class="col-12 col-lg-4">
          <label class="form-label fw-semibold">NIT</label>
          <input type="text" class="form-control form-control-lg" formControlName="nit"
            placeholder="Ej: CF, 4564854K, ND" />
        </div>

        <div class="col-12 col-lg-4">
          <label class="form-label fw-semibold">Actividad Empresa</label>
          <select class="form-select form-select-lg edit-desktop-select" formControlName="fkActividadEmpresa">
            <option [ngValue]="0">Seleccione...</option>
            @for (a of actividades(); track a.pk) {
            <option [ngValue]="a.pk">{{ a.descripcion }}</option>
            }
          </select>
          <div class="edit-mobile-picker">
            <button
              type="button"
              class="btn btn-outline-info edit-mobile-picker__button"
              (click)="openMobileSelect('fkActividadEmpresa', 'Actividad Empresa', getActividadMobileOptions())">
              <span class="edit-mobile-picker__value">{{ getMobileSelectionLabel('fkActividadEmpresa', 'Seleccione actividad empresa') }}</span>
              <span class="edit-mobile-picker__action">
                <i class="bi bi-search"></i>
                Buscar
              </span>
            </button>
          </div>
        </div>

        <div class="col-12 col-lg-4">
          <label class="form-label fw-semibold">Tamaño Empresa</label>
          <select class="form-select form-select-lg edit-desktop-select" formControlName="fkTamanoEmpresa">
            <option [ngValue]="0">Seleccione...</option>
            @for (t of tamanios(); track t.pk) {
            <option [ngValue]="t.pk">{{ t.descripcion }}</option>
            }
          </select>
          <div class="edit-mobile-picker">
            <button
              type="button"
              class="btn btn-outline-info edit-mobile-picker__button"
              (click)="openMobileSelect('fkTamanoEmpresa', 'Tamaño Empresa', getTamanoEmpresaMobileOptions())">
              <span class="edit-mobile-picker__value">{{ getMobileSelectionLabel('fkTamanoEmpresa', 'Seleccione tamaño empresa') }}</span>
              <span class="edit-mobile-picker__action">
                <i class="bi bi-search"></i>
                Buscar
              </span>
            </button>
          </div>
        </div>

        <div class="col-12 col-lg-6">
          <label class="form-label fw-semibold">Código CIIU</label>
          <input class="form-control form-control-lg" formControlName="codigoCIIU" />
        </div>
      </div>
    </section>

    <section class="edit-form-section">
      <h6 class="edit-section-title">Información Adicional</h6>

      <div class="row g-3">
        <div class="col-12 col-lg-6">
          <label class="form-label fw-semibold">Comentarios</label>
          <textarea class="form-control form-control-lg" rows="3" formControlName="comentarios"></textarea>
        </div>

        <div class="col-12 col-lg-6">
          <label class="form-label fw-semibold">Referencia</label>
          <textarea class="form-control form-control-lg" rows="3" formControlName="referencia"></textarea>
        </div>

        <div class="col-12">
          <label class="form-label fw-semibold">Información Adicional</label>
          <textarea class="form-control form-control-lg" rows="3" formControlName="informacionAdicional"></textarea>
        </div>
      </div>
    </section>

  </div>

  <!-- FOOTER -->
  <div class="modal-footer edit-modal-footer px-3 px-md-4 py-3">
    <div class="edit-modal-actions">
      <!-- <button type="button" class="btn btn-outline-danger edit-action-btn edit-action-btn-delete" (click)="openDeleteModal(fountain)">
        <i class="bi bi-trash"></i>
        Eliminar
      </button> -->

      <button
        type="button"
        class="btn btn-info text-white edit-action-btn"
        (click)="openGenerateBoletaModal()"
        [disabled]="saving() || generatingBoleta() || loadingOpenMonths()">
        @if (loadingOpenMonths()) {
        <span class="spinner-border spinner-border-sm"></span>
        Consultando meses...
        } @else if (generatingBoleta()) {
        <span class="spinner-border spinner-border-sm"></span>
        Generando boleta...
        } @else {
        <i class="bi bi-file-earmark-plus"></i>
        Generar boleta
        }
      </button>

      <button type="button" class="btn btn-danger text-white edit-action-btn" data-bs-dismiss="modal" [disabled]="saving()">
        <i class="bi bi-x-circle"></i>
        Cancelar
      </button>

      <button type="submit" class="btn btn-info text-white edit-action-btn edit-action-btn-primary"
        [disabled]="saving() || editForm.invalid">
        @if (saving()) {
        <span class="spinner-border spinner-border-sm"></span>
        Guardando...
        } @else {
        <i class="bi bi-check-circle"></i>
        Guardar Cambios
        }
      </button>
    </div>
  </div>

</form>

@if (openMonthsModalOpen()) {
<div class="boleta-months-overlay" (click)="closeOpenMonthsModal()">
  <div class="boleta-months-dialog" (click)="$event.stopPropagation()">
    <div class="boleta-months-dialog__header">
      <div>
        <small class="boleta-months-dialog__eyebrow">Boleta nueva</small>
        <h5 class="mb-1">Seleccione el mes habilitado</h5>
        <p class="mb-0 text-muted">
          Se mostrará el nombre del mes, pero el sistema enviará el identificador numérico correspondiente.
        </p>
      </div>

      <button type="button" class="btn-close" aria-label="Cerrar" (click)="closeOpenMonthsModal()"></button>
    </div>

    <div class="boleta-months-dialog__body">
      @for (option of openPublicationMonthOptions(); track option.key) {
      <button
        type="button"
        class="boleta-months-option"
        [class.is-active]="isSelectedOpenPublicationMonth(option)"
        (click)="selectOpenPublicationMonth(option)">
        <span class="boleta-months-option__label">{{ option.label }}</span>
        <span class="boleta-months-option__meta">Mes ID {{ option.month.mes }}</span>
      </button>
      }
    </div>

    <div class="boleta-months-dialog__footer">
      <button
        type="button"
        class="btn btn-danger text-white edit-action-btn"
        (click)="closeOpenMonthsModal()"
        [disabled]="generatingBoleta()">
        <i class="bi bi-x-circle"></i>
        Cancelar
      </button>

      <button
        type="button"
        class="btn btn-info text-white edit-action-btn edit-action-btn-primary"
        (click)="confirmGenerateBoleta()"
        [disabled]="generatingBoleta()">
        @if (generatingBoleta()) {
        <span class="spinner-border spinner-border-sm"></span>
        Generando boleta...
        } @else {
        <i class="bi bi-check-circle"></i>
        Confirmar generación
        }
      </button>
    </div>
  </div>
</div>
}

@if (mobileSelectOpen()) {
<div class="edit-mobile-select-overlay" (click)="closeMobileSelect()">
  <div class="edit-mobile-select-sheet" (click)="$event.stopPropagation()">
    <div class="edit-mobile-select-sheet__header">
      <div>
        <small class="edit-mobile-select-sheet__eyebrow">Selección rápida</small>
        <h5 class="mb-0">{{ mobileSelectTitle() }}</h5>
      </div>

      <button type="button" class="btn-close" aria-label="Cerrar" (click)="closeMobileSelect()"></button>
    </div>

    <div class="edit-mobile-select-sheet__search">
      <div class="input-group input-group-lg">
        <span class="input-group-text">
          <i class="bi bi-search"></i>
        </span>
        <input
          type="text"
          class="form-control"
          placeholder="Buscar opción..."
          [value]="mobileSelectQuery()"
          (input)="updateMobileSelectQuery($event)" />
      </div>
    </div>

    <div class="edit-mobile-select-sheet__options">
      @if (filteredMobileSelectOptions().length === 0) {
      <div class="edit-mobile-select-sheet__empty">
        No se encontraron opciones.
      </div>
      } @else {
      @for (option of filteredMobileSelectOptions(); track option.value) {
      <button
        type="button"
        class="edit-mobile-select-option"
        [class.is-active]="isActiveMobileSelectOption(option)"
        (click)="applyMobileSelectOption(option)">
        <span>{{ option.label }}</span>
        @if (isActiveMobileSelectOption(option)) {
        <i class="bi bi-check-circle-fill"></i>
        }
      </button>
      }
      }
    </div>
  </div>
</div>
}

<!-- MODAL ELIMINAR (igual lo dejas como estaba) -->
<div class="modal fade" id="deleteModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <app-modal-delete-source [fountain]="selectedFountain" (deleted)="onDeleted()">
      </app-modal-delete-source>
    </div>
  </div>
</div>
